export default __webpack_public_path__ + "static/thaiQR-016bfb1780af4b099d5617743ce265ee.png";